module.exports = __webpack_public_path__ + "img/trace_abbreviation.6eac511b.png";